"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const WHY_CHOOSE_BASE = "/image/new-version/casting/Sand-Casting/Why-Choose";

const CARDS = [
	{
		keyPrefix: "whyChooseFeature1",
		image: `${WHY_CHOOSE_BASE}/professional-sand-casting-solutions.webp`,
		panelClassName: "bg-black",
		indexAccentClassName: "text-[#c8e085]",
	},
	{
		keyPrefix: "whyChooseFeature2",
		image: `${WHY_CHOOSE_BASE}/high-quality-sand-castings.webp`,
		panelClassName: "bg-[#506637]",
		indexAccentClassName: "text-[#c8e085]",
	},
	{
		keyPrefix: "whyChooseFeature3",
		image: `${WHY_CHOOSE_BASE}/guaranteed-lead-times.webp`,
		panelClassName: "bg-[#91a162]",
		indexAccentClassName: "text-[#4d6b3a]",
	},
	{
		keyPrefix: "whyChooseFeature4",
		image: `${WHY_CHOOSE_BASE}/expert-casting-engineering.jpg`,
		panelClassName: "bg-[#85b488]",
		indexAccentClassName: "text-[#4d6b3a]",
	},
	{
		keyPrefix: "whyChooseFeature5",
		image: `${WHY_CHOOSE_BASE}/flexible-production-capabilities.webp`,
		panelClassName: "bg-[#107e03]",
		indexAccentClassName: "text-[#c8e085]",
	},
	{
		keyPrefix: "whyChooseFeature6",
		image: `${WHY_CHOOSE_BASE}/proven-industry-applications.webp`,
		panelClassName: "bg-[#9ec687]",
		indexAccentClassName: "text-[#4d6b3a]",
	},
] as const;

export default function WhyChooseSandCasting() {
	const t = useTranslations("new-sand-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("whyChooseTitle")}
					</h2>
				</header>

				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8 lg:grid-cols-3 lg:gap-6">
					{CARDS.map((card) => {
						const isLight = card.panelClassName.includes("9ec687");
						return (
							<article
								key={card.keyPrefix}
								className="flex flex-col overflow-hidden border border-gray-200 bg-white shadow-sm"
							>
								<div className="relative aspect-[4/2] w-full bg-[#f5f7fa]">
									<Image
										src={card.image}
										alt={t(`${card.keyPrefix}ImageAlt`)}
										fill
										className="object-cover"
										sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
									/>
								</div>
								<div className={`flex flex-1 flex-col px-5 py-6 sm:px-6 sm:py-7 ${card.panelClassName}`}>
									<p
										className={`mb-2 text-sm font-medium tracking-wide sm:mb-3 sm:text-base ${card.indexAccentClassName}`}
									>
										{t(`${card.keyPrefix}Index`)}
									</p>
									<h3
										className={`mb-2 text-lg font-bold leading-snug text-white sm:mb-3 sm:text-xl md:text-2xl`}
									>
										{t(`${card.keyPrefix}Title`)}
									</h3>
									<p className={`text-sm leading-relaxed text-white/90 md:text-base`}>
										{t(`${card.keyPrefix}Desc`)}
									</p>
								</div>
							</article>
						);
					})}
				</div>
			</div>
		</section>
	);
}
